const ZuoraActionType = {
  DISABLE_SUBMIT: 'ZUORA_DISABLE_SUBMIT',
  HIDE_LOADING: 'ZUORA_HIDE_LOADING',
  STORE_ZUORA_INFO: 'ZUORA_STORE_INFO'
};

export default ZuoraActionType;



/** WEBPACK FOOTER **
 ** ./src/common/ZuoraActionType.js
 **/